


















































































  import {Component, Vue, Watch} from 'vue-property-decorator'
  import kepler from "@/../lib/kepler_sdk/kepler";
  import ACard from "@/components/UI/ACard.vue";
  import NMapMarker from "../../../lib/n-maps/NMapMarker.vue";
  import ACardPlus from "@/components/UI/ACardPlus.vue";
  import AvailabilityBtnGroup from "@/components/UI/AvailabilityBtnGroup.vue";
  import BookingDetail from "@/views/Bookings/BookingDetail.vue";
  import TableCell from "@/views/UI/TableCell.vue";
  import ReportingTableCard from "@/components/UI/ReportingTableCard.vue";
  import ReservationTableCard from "@/components/UI/ReservationTableCard.vue";
  import VehicleMiniCard from "@/components/UI/VehicleMiniCard.vue";
  import ParkingLotMiniCard from "@/components/UI/ParkingLotMiniCard.vue";
  import moment from 'moment';
  import HardwareInfo from "@/components/UI/HardwareInfo.vue";
  import schemaHelper from "../../../lib/kepler_sdk/schemaHelper";
  import SmartForm from "../../../lib/smart-form/SmartForm.vue";
  import notifications from "../../../lib/notifications";



  @Component({
    components: {
      HardwareInfo,
      VehicleMiniCard,
      ParkingLotMiniCard,
      ReservationTableCard,
      ReportingTableCard, BookingDetail, ACard, ACardPlus, NMapMarker, AvailabilityBtnGroup,TableCell, SmartForm},
  })
  export default class Assets extends Vue {
    public vehicle = null
    public availability = null
    public managers = null
    public loadValue = 0
    public loading:boolean = true

/// Data for AVAILABILITY card
    public start = 0
    public end =  0
    public lastDate = ''
    public url:any = ''

///Data for RESERVATIONS card
    public items:any = []
    public options = {
      page: 1,
      itemsPerPage: 5
    }
    public totalItems = null
    public totalPages = null


///Data for REPORTINGS card
    public reportingOptions = {
      page: 1,
      itemsPerPage: 5
    }
    public reportingsItems:any = []
    public reportingTotalItems = null
    public reportingTotalPages = null
/// Data for Cost
    public dates:any = ['2020-06-10', '2020-06-20']
    public modal = false
    public menu= false



    public mounted() {
      // Setting date time for availability component
      const myDate = new Date()
      myDate.setMinutes(0)
      myDate.setSeconds(0)
      myDate.setMilliseconds(0)

      this.start = Math.round(myDate.getTime() / 1000)
      myDate.setDate(myDate.getDate() + 1)
      this.end = Math.round(myDate.getTime() / 1000)
      this.dataLoad()

    }
    public dateRangeText() {
      return this.dates.join(' ~ ')
    }

/// SmartForm START
    public model: any = {}
    public schema: any = {}
    public dialog = false;
    public saveDisable = false;
    public schemaName = 'asset_cost_record'

    public openNewForm(){
      this.dialog = false;
      this.schema = schemaHelper(this.schemaName)

      this.$nextTick(() => {
        this.dialog = true;
      })
    }
    public saveForm() {
      let data= {
        amount : this.model.amount,
        asset_cost_record_type_id: this.model.asset_cost_record_type.id,
        date: this.model.date,
        description: this.model.description,
        tax: this.model.tax
      }
    console.log(this.model)
      kepler.postSingle('add_cost', this.$route.params.id, data)!.then(() => {
        notifications.notify("success", "ITEM CREATED")
        this.closeForm()
      }).catch(this.notifyError)
    }
    public closeForm() {
      this.dialog = false;
    }
    public notifyError(error: any) {
      notifications.notify("error", error.response.status + ": " + JSON.stringify(error.response.data, null, 2))
    }
    private dataLoad() {

      kepler.getSingle('vehicle', this.$route.params.id)!.then((d) => {
        this.vehicle = d.data
        this.loadValue = 25
        this.loadAvailability()
      })
    }
    private loadAvailability(loadManager:boolean= true) {
      kepler.postSingle('availability', this.$route.params.id, {
        start: this.start,
        end: this.end
      })!.then((response) => {
        this.availability = response.data
        if(loadManager) {
          this.loadValue = 50
          this.loadManagers()
        }


      })
    }
    private loadManagers() {

          kepler.get('managers')!.then((d) => {
            this.managers = d.data
            this.loadValue = 75
            this.loadReservation()
            this.loadReporting()
          })
    }
   // @Watch('options', {deep: true})
    private loadReservation() {
      this.loading = true
      kepler.getSingle('movements', this.$route.params.id, this.options)!.then((d) => {
        this.totalItems = d.data.items_count
        this.totalPages = d.data.page_count
    //sort provvisorio in attesa di API V3
        if (Array.isArray(d.data.items)) {
          this.items = d.data.items
            .sort((a:any,b:any) =>{
                if(a.id < b.id) return 1
                if(a.id > b.id) return -1
                return 0
          })
        }
        this.loading = false

      })
    }

    private loadReporting() {
      this.loading = true
      kepler.postSingle('reportings','',{
        status: null,
        vehicle_id: this.$route.params.id
      },this.reportingOptions)!.then((response) => {
        this.reportingTotalItems = response.data.items_count
        this.reportingTotalPages = response.data.page_count
        this.reportingsItems = response.data.items
        this.loadValue = 100
        this.loading = false
      })
    }

    public selectedReportingOptions(options:any) {
      this.reportingOptions = options
      this.loadReporting()
    }
    public selectedReservationOptions(options:any) {
      this.options = options
      this.loadReservation()
    }

    public getLastDate(item: any) {
    // retrieve the last day(year-month-day) showed in the availability card
      this.lastDate = item
    }
    public getManifacturer(item:string) {
      let el = item.replace(/\\/g, '/').split('/')
      return el.pop()
    }
    public loadOther() {
      //recalculanting the end date to pass to endpoint by lastDay retrieved
      const newEndDate = new Date(this.lastDate)
      newEndDate.setHours(23)
      newEndDate.setMinutes(59)
      newEndDate.setSeconds(59)
      newEndDate.setMilliseconds(59)
      newEndDate.setDate(newEndDate.getDate() + 1)
      this.end = Math.round(newEndDate.getTime() / 1000)

      this.loadAvailability(false)
    }

  }
